import 'font-awesome/css/font-awesome.min.css'
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#FBCC04',
        secondary: '#89B8FA',
        accent: '#8D8F96',
        error: '#FF6060',
        info: '#2196F3',
        success: '#47CC95',
        warning: '#FFC107',
        background: '#172530',
      },
      dark: {
        primary: colors.blue.base,
        secondary: colors.amber.base,
        accent: colors.lightBlue.base,
        error: colors.red.base,
        info: colors.blue.lighten3,
        success: colors.green.base,
        warning: colors.orange.base,
        background: colors.indigo.base,
      },
    },
  },
  icons: {
    iconfont: 'mdi',
    iconfont: 'fa4',
  },
});
